const credentials = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '';
export const isUserExist = () => JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user'))['profile'];
export const getToken = () => JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user'))['access_token'];
export const getCredential = () => JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user'));
export default {
  details: getCredential(),
  profile: getCredential() && getCredential().profile,
  token: getCredential() && getCredential().access_token,
};
